import React from "react";
import Footer from "../inc/Footer";

function BuyersServices() {

  return (
    <div >
      <div className="container-fluid text-center justify-content-center align-items-center pb-5 m-0 p-0">
        <img src={window.location.origin + '/images/buyer_service.png'} className="img-fluid" alt="buyer services" />
      </div>
      <div className="container mb-3 mt-5 mb-5">

        <div className="row">
          <div className="col-md-6 col-12">
            <div className="serviceBox2 mt-5 d-flex justify-content-center align-items-center">
            <p style={{marginTop:"-30px"}}>Diverse range of vehicles suiting everyone’s taste.</p>
            </div>
          </div>
          <div className="col-md-6 col-12">
          <div className="serviceBox2 d-flex justify-content-center align-items-center">
          <p style={{marginTop:"-30px"}}>Convenience of bidding online providing ease of access.</p>
            </div>
          </div>
                    
        </div>

        <div className="row">
          <div className="col-md-6 col-12">
            <div className="serviceBox2 mt-5 d-flex justify-content-center align-items-center">
            <p style={{marginTop:"-30px"}}>Simple and Transparent process for enhanced reliance. </p>
            </div>
          </div>
          <div className="col-md-6 col-12">
          <div className="serviceBox2 d-flex justify-content-center align-items-center">
          <p style={{marginTop:"-30px"}}> Multiple means of communication (Phone/Email/WhatsApp, etc.)</p>
            </div>
          </div>
                    
        </div>

        <div className="row">
          <div className="col-md-6 col-12">
            <div className="serviceBox2 mt-5 d-flex justify-content-center align-items-center">
            <p style={{marginTop:"-30px"}}>Open platform for queries and feedback sharing for healthier <br/>partnership.</p>
            </div>
          </div>
          
                    
        </div>


       

        
      </div>
      
      <Footer />
    </div>
  );
}

export default BuyersServices;
